<template>
  <div class="marketingProjectEditor">
    <div style="display: flex;justify-content: space-around;">
      <el-button style="margin: 10px 20px" size="mini" type="primary" @click="back()">返回</el-button>
      <div>

        <el-dialog title="选择队长并组建团队" :visible.sync="formTeamDialogVisible" width="500px"
          style="margin-top:7vh !important;">
          <!-- 组建团队 -->
          <div style="width: 450px;margin:0 auto;padding: 10px;background: #f9f9fa;">
            <el-table @selection-change="handleSelectionChange" :data="UserList" stripe style="width: 100%;">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="id" label="序号" width="80"> </el-table-column>
              <el-table-column prop="studentName" label="姓名">
              </el-table-column>
              <el-table-column prop="studentNumber" label="学号">
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button @click="delstu(scope.row)" size="mini"> 删除 </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 班级公司管理分页 -->
            <div class="selectePages">
              <el-pagination @size-change="classCompanySizeChange" @current-change="classCompanyCurrentChange"
                :current-page.sync="totalObj.currentPage" background :page-sizes="[10, 20, 50, 100]"
                :page-size="totalObj.pageSize" layout="sizes, prev, pager, next" :total="totalObj.total">
              </el-pagination>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="formTeamDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="companyTeamFuntion()">确 定</el-button>
          </span>
        </el-dialog>






        <el-button style="margin: 10px 20px" size="mini" type="primary" plain @click="addStuStaff()">组件团队
        </el-button>
        <!-- <el-button style="margin: 10px 20px" size="mini" type="primary" plain @click="RandomTeam()">随机组队 -->
        <!-- </el-button> -->
<!--        <el-button style="margin: 10px 20px" size="mini" type="primary" plain @click="Assigned_project()">分配项目
        </el-button> -->
      </div>

    </div>
    <div v-if="Transfer == 1">
      <el-dialog title="添加学生" custom-class="add_stu" center width="982px" :show-close="false"
        :visible.sync="centereDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false"
        :before-close="add_all_student_cancel">
        <div class="sudent-contents">
          <!-- 待选 -->
          <div class="sudent-content">
            <div class="selected tobe">
              <div class="seach">
                <span>待选</span>
                <div class="training-site">
                  <el-input v-model="queryVal" placeholder="请输入姓名/学号/手机号/账号" size="mini"
                    style="width: 200px; height: 28px; float: left" @keyup.enter.native="search_student">
                    <i slot="suffix" @click="search_student" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <el-select v-model="teachingClass" @change="teachingClassChange" placeholder="请选择行政班" clearable>
                    <el-option v-for="(item, key) in options" :key="key" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="left-table">
                <el-table ref="multipleTable2" :data="tableData_3" :cell-style="cellStyle3"
                  :header-cell-style="headerCellStyle3" :row-style="{ border: 0 }" style="width: 100%" height="256px"
                  :row-key="getRowKey" @selection-change="check_student">
                  <el-table-column width="50" type="selection" align="center" :reserve-selection="true">
                  </el-table-column>
                  <el-table-column prop="name" label="姓名"></el-table-column>
                  <el-table-column prop="studentNumber" label="学号"></el-table-column>
                  <el-table-column prop="teachingClass" label="行政班"></el-table-column>
                </el-table>
              </div>
              <!-- 分页 -->
              <div class="pages">
                <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                  :current-page.sync="currentPage2" background :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                  :pager-count="5" layout="sizes, prev, pager, next" :total="studentTotal"></el-pagination>
              </div>
            </div>
            <!-- button  -->
            <div class="box_button">
              <el-button type="primary" @click="add_active" :disabled="!table_student.length" class="button_top"
                icon="el-icon-arrow-right" circle></el-button>
              <el-button type="primary" @click="remove_active" :disabled="!table_student2.length"
                icon="el-icon-arrow-left" circle></el-button>
            </div>
            <!-- 已选 -->
            <div class="selected">
              <div class="seach">
                <span>已选</span>
                <div class="training-site">
                  <el-input v-model="queryVal2" placeholder="请输入姓名/学号/手机号/账号" size="mini"
                    style="width: 210px; height: 28px" @keyup.enter.native="query_student2(queryVal2)">
                    <i slot="suffix" @click="query_student2(queryVal2)" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
              </div>
              <div class="">
                <el-table :data="tagList" :cell-style="cellStyle3" :header-cell-style="headerCellStyle3"
                  :row-style="{ border: 0 }" style="width: 100%" height="301px" @selection-change="check_student2">
                  <el-table-column width="50" type="selection" align="center"></el-table-column>
                  <el-table-column prop="name" label="姓名"></el-table-column>
                  <el-table-column prop="studentNumber" label="学号"></el-table-column>
                  <el-table-column prop="teachingClass" label="行政班"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="add_all_student_cancel">取 消</el-button>
          <el-button type="primary" @click="add_all_student">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="StuStaff == 1">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="926px" border-radius="25px">
        <span>
        </span>
        <div v-for="(item, id) in subjectIds" :key="id">
          <div style="
                border: #e6e8f1 1px solid;
                display: flex;
                flex-direction: column;
              ">
            <span style="margin: 0px 0 5px 0; justify-content: space-between">
              <div style="
                    width: 100%;
                    height: 30px;
                    background-color: #e6e8f1;
                    display: flex;
                    align-items: center;
                  ">
                <span>{{item.projectName}}</span>
              </div>

              <div style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  ">
                <span>指派给:</span>

                <el-popover placement="bottom" title="标题" width="200" trigger="click">
                  <el-checkbox-group style="display: flex; flex-direction: column" v-model="item.checkList">
                    <div v-for="(a, id) in UserList" :key="id">
                      <el-checkbox :label="a">{{
                          a.studentName
                        }}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                  <el-button size="mini" style="border: none; background-color: white" slot="reference"><i
                      style="font-size: 20px" class="el-icon-circle-plus-outline" @click="addstu"></i></el-button>
                </el-popover>
              </div>
            </span>

            <span>
              <el-tag style="margin: 5px" v-for="tag in item.checkList" :key="tag.studentName" closable>
                {{ tag.studentName }}
              </el-tag>
            </span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addStuProject">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="display: flex;flex-wrap: wrap;margin: 0 auto;background: white; height: 90%;">
      <el-card class="box-card" v-for="(item,id) in companyTeamList" :key="id" style="position: relative;">
        <p style="font-size: 18px;font-weight: 600;">{{item.userList[0].studentName}}的项目组</p>
        <div   style="display: flex;margin: 10px 0px;">
          <p style="width: 50px;flex:none">成员：</p>
        <div style="width: 150px;display: flex;flex-wrap: wrap;overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;">
            <span style="font-size: 12px;margin-right: 3px;" v-for="(a,id) in item.userList" :key="id">{{a.studentName}}  、</span>
          </div>
        </div>
        <div  style="position:absolute;bottom: 0px;right: 20px;">
          <el-button type="text" @click="editStudent(item.userList)">编辑</el-button>
        </div>
      </el-card>
    </div>

    <el-dialog title="团队名单" :visible.sync="EditStatusDialogVisible" width="45%">

      <el-dialog width="30%" title="新增学员" :visible.sync="innerVisible" append-to-body>
        <el-table ref="multipleTable" :data="UserList" tooltip-effect="dark" style="width: 100%"
          @selection-change="handleSelectionStudentChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" width="120">
            <template slot-scope="scope">{{ scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="studentName" label="姓名">
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: space-around;">
          <el-button type="text" @click="addStudentForTeam()">新增</el-button>
        <el-button type="text" @click="innerVisible = false">取消</el-button>
        </div>

      </el-dialog>
      <el-button type="text" @click="addStudent()">新增成员</el-button>
      <el-button type="text" @click="delStudent()">删除成员</el-button>
      <el-table ref="multipleTable" :data="teamStudentList" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionStudentChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">{{ scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="studentName" label="姓名">
        </el-table-column>
        <el-table-column label="团队身份">
          <template slot-scope="scope">{{ scope.$index==0 ? "队长" : "队员"}}</template>
        </el-table-column>


      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="EditStatusDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditStatus()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import * as api from "../../../api/marketingProjectManagement"; // 内容展示
  import router from '../../../router';

  export default {
    // props:["classCompany"],
    data() {
      return {
        allTeamUser:[],
        teamID:-1,
        peopleNumber:-1,
        innerVisible: false,
        teamStudentList: [],
        EditStatusDialogVisible: false,
        // 组件团队
        companyTeamList: [],
        formTeamDialogVisible: false,
        multipleSelection: [],
        SelectionStudent: [],
        professional: sessionStorage.getItem("professional"),
        selectCompanyId: "",
        select_projectList: [],
        projectList: [],
        checkList: [],
        tableData: [],
        classCompany: [],
        materialForm: {
          url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
          data: {
            savepath: "cjdd/resourse/",
          },
          fileName: "",
          id: this.$route.query.id,
        },
        centereDialogVisible: false,
        tagList: [],
        queryVal2: "",
        table_student: [], //  选中学生列表 待选
        table_student2: [], //  选中学生列表  选中
        studentTotal: 0,
        pageSize: 10,
        currentPage2: 0,
        border: "",
        tableData_3: [],
        options: "",
        teachingClass: "",
        queryVal: "",
        StuStaff: -1,
        Transfer: -1,
        selectedStudentList: [],
        queryStudentList: [],
        UserList: [],
        answerList: [], //单选题多选题的数据状态集合
        courseId: sessionStorage.getItem("courseId"),
        dialogVisible: false,
        pop_up_box: false,
        pageTotal: {
          pageSize: 0,
          currentPage: 0,
          total: 0,
        },
        totalObj: {
          pageSize: 1000,
          currentPage: 1,
          total: 0,
        },
        id: this.$route.query.id,
        subjectId: this.$route.query.subjectId,
        subjectIds: [],
        companyName: "",
        companyContext: "",
        companyLogo: "",
        companyId: "",
        studentUserId: "",
        personnelManagement: 1,
      };
    },
    created() {
      this.init();
      this.findCompanyTeamList()
      this.getStudentList();
      this.getTeachingClass();
      this.personnelManagementFuntion();
    },
    mounted() {},
    computed: {
      headers() {
        return {
          Authorization: "bearer " + localStorage.getItem("Authorization"),
        };
      },
    },
    methods: {
      editStudent(val) {
        this.EditStatusDialogVisible = true
this.teamID = val[0].teamId
        let params = {
          "id":val[0].teamId
        }
        api.CompanyTeamDetails(params).then(
        (res) => {
          if (res.code == 0) {
            this.teamStudentList = [...res.data.userList]
          }
        },
        )
      },
      // 更改状态
      EditStatus() {
        this.EditStatusDialogVisible = true
      },
      // 随机组队
      RandomTeam(){
        let params = {
          "companyId" : this.$route.query.id,
          num : this.peopleNumber
        }
// generateByRandom
      },
      // 组件团队
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleSelectionStudentChange(val) {
        this.SelectionStudent = val;
      },
      addStudent() {
        this.innerVisible = true
        for (let a = 0; a < this.companyTeamList.length; a++) {
          for (let i = 0; i < this.UserList.length; i++) {
            if (this.UserList[i].studentUserId == this.companyTeamList[a].userList[0].studentUserId) {
              this.UserList.splice(i, 1)
            }
          }
        }
      },
      addStudentForTeam() {
        let userTeamList = []
        let params = {
          "companyId": this.$route.query.id,
          "userList": userTeamList
        }
        for (let a = 0; a < this.SelectionStudent.length; a++) {
          userTeamList.push({
            "studentName": this.SelectionStudent[a].studentName,
            "studentUserId": this.SelectionStudent[a].studentUserId,
            "teamId": this.teamStudentList[0].teamId
          })
        }
        api.companyTeamInsert(params).then(
          (res) => {
            if (res.code == 0) {
            }
          },
        );
this.innerVisible =false
      let data = {
        "id":this.teamID
      }
      api.CompanyTeamDetails(data).then(
      (res) => {
        if (res.code == 0) {
          this.teamStudentList = [...res.data.userList]
        }
      },
      )
      },
      delStudent() {
        let studentUser = []
        for (let a = 0; a < this.SelectionStudent.length; a++) {
          studentUser.push(
            this.SelectionStudent[a].id,
          )
        }
let params = [...studentUser]


api.deleteUser(params).then(
(res) => {
  if (res.code == 0) {
  }
},
)
      let data = {
        "id":this.teamID
      }
      api.CompanyTeamDetails(data).then(
      (res) => {
        if (res.code == 0) {
          this.teamStudentList = [...res.data.userList]
        }
      },
      )
      },
      findCompanyTeamList() {
        let params = {
          "companyId": this.$route.query.id,
        }
        api.findCompanyTeamList(params).then(
          (res) => {
            if (res.code == 0) {
              this.companyTeamList = res.data
              // this.allTeamUser = res.data
              for (let index = 0; index < this.companyTeamList.length; index++) {
                              for (let a = 0; a < this.companyTeamList[index].userList.length; a++) {
                this.allTeamUser.push(this.companyTeamList[index].userList[a].studentUserId);
              }
              }
console.log(this.allTeamUser,"this.allTeamUser");
            }
          },
        );
      },

      // 选择队长创建团队
      companyTeamFuntion() {
        this.formTeamDialogVisible = false
        this.companyTeamList = this.multipleSelection
        for (let a = 0; a < this.companyTeamList.length; a++) {
          let params = [{
            "companyId": this.companyTeamList[a].companyId,
            "userList": [{
              "studentName": this.companyTeamList[a].studentName,
              "studentUserId": this.companyTeamList[a].studentUserId,
            }]
          }]
          api.saveTeamByCap(params).then(
            (res) => {
              if (res.code == 0) {
                console.log(res, "saveTeamByCap")
              }
            },
          );
          this.findCompanyTeamList()
        }



      },
      add_all_student() {
        if (this.addStudentList.length) {
          let newArr = [];
          this.addStudentList.forEach((item) => {
            var obj = {};
            obj.studentName = item.name;
            obj.studentNumber = item.studentNumber;
            obj.studentUserId = item.id;
            obj.className = item.teachingClass;
            obj.mobile = item.mobile;
            newArr.push(obj);
          });
          let data = {
            companyId: this.id,
            entityList: newArr,
          };
          api.Usersave(data).then(
            (data) => {
              if (data.code == 0) {
                this.centereDialogVisible = false;
                this.$messageSuccess("添加成功");
                this.personnelManagementFuntion(this.id); // 人事管理列表
                this.tagList = [];

                this.list_st = [];
                this.addStudentList = [];
              } else {
                this.$messageInfo(data.msg);
              }
            },
            (e) => {
              this.$messageError(e);
            }
          );

        } else {
          this.$messageInfo("请选择");
        }
        this.formTeamDialogVisible = true
      },





      init() {
        this.params = {
          subjectId: this.id,
        };
        api.CompanyList(this.params).then((res) => {
          if (res.code == 0) {
            this.classCompany = res.data.records;
          }
        });

      },
      add_active() {
        // 添加到选中
        this.tagList = [];
        this.addStudentList = [];
        this.list_st = [];
        this.table_student.forEach((item) => {
          this.tagList.push(item);
          this.list_st.push(item);
          this.addStudentList.push(item);
        });
        this.table_student = [];
        this.query_student();
      },
      remove_active() {
        // 删除选中
        this.table_student2.forEach((items) => {
          this.tagList.forEach((item, i) => {
            if (items.id == item.id) {
              this.tagList.splice(i, 1);
              this.list_st.splice(i, 1);
            }
          });
          this.addStudentList.forEach((item, i) => {
            if (items.id == item.id) {
              this.addStudentList.splice(i, 1);
            }
          });
        });
        this.table_student2 = [];
        this.query_student();
      },
      cellStyle3(data) {
        if (data.columnIndex == 0) {
          return "text-algin:center !important;";
        } else {
          return "text-align:left !important;padding-left: 20px!important;";
        }
      },
      headerCellStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex === 0 && columnIndex === 0) {
          return "text-algin:center !important;";
        }
      },
      cellStyle(data) {
        if (data.columnIndex == 0) {
          return "text-algin:center !important";
        }
      },
      headerCellStyle3({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex === 0 && columnIndex === 0) {
          return "background:rgba(83,151,247,0.1);color:#999999;text-algin:center !important;";
        } else {
          return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;padding-left: 20px!important;";
        }
      },
      check_student2(list) {
        this.table_student2 = list;
      },


      search_student() {
        this.currentPage2 = 1;
        this.query_student();
      },
      getRowKey(row) {
        return row.id;
      },
      check_student(list) {
        // 选中待选
        this.table_student = list;
      },
      handleSizeChange2(val) {
        this.currentPage2 = 1;
        this.pageSize = val;
        this.query_student();
      },
      handleCurrentChange2(val) {
        this.currentPage2 = val;
        this.query_student();
      },
      teachingClassChange(val) {
        this.teachingClass = val;
        this.query_student();
      },
      add_all_student_cancel() {
        this.centereDialogVisible = false;
        this.queryVal = "";
        this.queryVal2 = "";
        this.currentPage2 = 1;
        this.addStudentList = [];
        this.query_student();
        this.pageSize = 10;
        this.$refs.multipleTable2.clearSelection();
      },
      open_dialog(a) {
        this.dialogVisible = true;
        this.companyName = a.companyName;
        this.companyContext = a.companyContext;
        this.companyLogo = a.companyLogo;
        this.id = a.id;
      },
      // 用公司id 获取公司下的学生
      personnelManagementFuntion(id) {
        this.companyId = id;
        let params = {
          companyId: this.id,
          pageSize: this.totalObj.pageSize,
          pageNo: this.totalObj.currentPage,
        };
        api.companyUserList(params).then((res) => {
            this.UserList = res.data.records;
            console.log(this.UserList,"this.UserList");
            let aaa = []
          if (res.code == 0) {
            for (let i = 0; i < this.UserList.length; i++) {
            for (const item of this.allTeamUser) {
              console.log(item,"item");
              if (this.UserList[i].studentUserId == item) {
                  aaa = this.UserList.splice(i,1)
                }
            }
                
                
              }
            
            console.log(aaa,"aaa");
            let virtualList = []
            for(let i = 0;i<this.UserList.length;i++){
              virtualList.push({name:this.UserList[i].studentName,teachingClass:this.UserList[i].className,studentNumber:this.UserList[i].studentNumber})
            }
            this.tagList = [...virtualList]
            for(let a = 0;a<this.tableData_3.length;a++){
              for(let b = 0;b<this.tagList.length;b++){
                if(this.tableData_3[a].studentName == this.tagList[a].studentName){
                  this.tableData_3[a].splice(a,1)
                }
              }
            }
            this.totalObj.total = res.data.total;
          }
        });
      },
      //保存
      handleSave() {
        this.dialogVisible = false;
        let params = {
          id: this.id,
          companyContext: this.companyContext,
          companyLogo: this.companyLogo,
          companyName: this.companyName,
          subjectId: this.subjectId,
        };
        if (this.id == "") {
          api.SaveCompany(params).then((res) => {
            if (res.code == 0) {
              this.init();
              this.$message({
                message: "新增成功",
                type: "success",
              });
              // this.answerList = res.data
            }
          });
        } else {
          api.updateCompany(params).then((res) => {
            if (res.code == 0) {
              this.init();
              this.$message({
                message: "修改成功",
                type: "success",
              });

              // this.answerList = res.data
            }
          });
        }
      },
      //删除
      del(a) {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.id = a.id;
            let params = {
              id: this.id,
            };
            api.deleteCompany(params).then((res) => {
              if (res.code == 0) {
                this.init();
                // this.answerList = res.data
              }
            });
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      handleAvatarSuccess(res, file) {
        if (res.code == 0) {
          this.companyLogo = res.data.newAttaUrl;
        } else {
          let fileId = file.uid;
          this.showUploadFileList.forEach((item) => {
            if (item.uid == fileId) {
              item.state = "上传失败";
            }
          });
          this.$message.error("格式不支持上传");
        }
      },
      addStuStaff() {
        this.personnelManagementFuntion()
        this.currentPage2 = 1;
        this.query_student();
        this.centereDialogVisible = true;
        this.Transfer = 1;
      },
      Assigned_project() {
        this.dialogVisible = true;
        this.StuStaff = 1;
        this.subjectIds = [];
        let params = {
          id: this.id,
          // subjectId :$route.query.subjectId
        };
        api.findById(params).then((res) => {
          if (res.code == 0) {
            res.data.list.forEach((item) => {
              item.checkList = [];
              this.subjectIds.push(item);
              this.subjectIds = [...new Set(this.subjectIds)]
            });
            this.personnelManagementFuntion(this.id);
          }
        });

      },
      // 查询所有的学员
      query_student() {
        // 查询学生
        let that = this;
        let obj = {
          limit: this.pageSize,
          page: that.currentPage2,
          name: that.queryVal,
          type: "2",
          status: "1",
          teachingClass: this.teachingClass,
        };
        api.getAllStudent(obj).then(
          (data) => {
            if (data.code == 0) {
              let datalist = data.data;
              that.studentTotal = datalist.total;
              that.tableData_3 = [];
              datalist.records.forEach((item) => {
                that.tableData_3.push({
                  userName: item.userName,
                  name: item.name,
                  studentNumber: item.studentNumber ? item.studentNumber : "--",
                  teachingClass: item.teachingClass ? item.teachingClass : "--",
                  id: item.userId,
                  mobile: item.mobile,
                });
              });
              if (that.tagList.length) {
                that.tagList.forEach((items) => {
                  that.tableData_3.forEach((item, i) => {
                    if (items.id == item.id) {
                      that.tableData_3.splice(i, 1);
                    }
                  });
                });
                let num = 0;
                that.tableData_3.forEach((v, i) => {
                  if (v.flag) {
                    num++;
                  }
                });
                if (num == 10) {
                  this.$refs.multipleTable.toggleAllSelection();
                }
              }
            } else {
              this.$messageInfo("没找到");
            }
          },
          (e) => {
            this.$messageError(e);
          }
        );
      },
      getStudentList() {
        let obj = {
          param: this.nameSum,
          className: this.className,
          classId: this.classId,
          page: this.pageTotal.currentPage,
          limit: this.pageTotal.pageSize,
          status: 1,
        };
        api
          .getStudentList(obj)
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.tableData = res.data.list;
              this.pageTotal.total = res.data.total;
              this.pageTotal.currentPage = res.data.pageNum;
              if (res.data.total > 10) {
                this.height = window.innerHeight - 290 + "px";
              } else {
                this.height = window.innerHeight - 240 + "px";
              }
            } else {
              this.loading = false;
              this.$messageError(res.msg);
            }
          })
          .catch((error) => {});
      },
      getTeachingClass() {
        api.getTeachingClass().then((res) => {
          if (res.code == 0) {
            this.options = res.data;
          }
        });
      },
      add_project() {
        this.params = {
          professionalId: this.professional,
        };
        api.projectList(this.params).then((res) => {
          if (res.code == 0) {
            res.data.records.forEach(function(item) {
              item.checkList = [];
            });
            this.projectList = res.data.records;
          }
        });
      },
      addstu() {
        this.pop_up_box = true;
      },
      delstu(q) {
        this.params = [q.id];
        api.delCompanyStaff(this.params).then((res) => {
          if (res.code == 0) {
            this.personnelManagementFuntion(this.id);
          }
        });
      },
      addStuProject() {
        this.dialogVisible = false;
        let param = [];
        this.subjectIds.forEach((item) => {
          let o = {
            companyId: this.id,
            ids: [],
            projectId: this.$route.query.projectId,
          };
          item.checkList.forEach((citem) => {
            o.ids.push(citem.id);
          });
          param.push(o);
        });
        api.distribute(param).then((res) => {
          if (res.code == 0) {
            this.personnelManagementFuntion(this.id);
          }
        });
      },
      //分页
      classCompanySizeChange(val) {
        this.totalObj.pageSize = val;
        this.personnelManagementFuntion();
      },
      classCompanyCurrentChange(val) {
        this.totalObj.currentPage = val;
        this.personnelManagementFuntion();
      },
      back() {
        this.$router.go(-1)
      }
    },
  };
</script>


<style lang="scss">
  .marketingProjectEditor {
    cursor: default;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f5f5f7;

    .upload_custom {

      .el-upload--picture-card,
      .el-upload-list__item {
        width: 80px;
        height: 80px;
      }

      .el-input__icon {
        line-height: 80px;
      }

      .el-upload {
        line-height: 80px;
      }
    }

    /*.el-upload-list__item-thumbnail{*/
    /*    width: 80px!important;*/
    /*    height: 80px!important;*/
    /*  }*/

    /*.el-input__icon{*/
    /*  margin-top: 18px;*/
    /*}*/

    /*.el-select__caret {*/

    /*}*/

    .seach {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 10px;
    }

    .sudent-content {
      display: flex;

      .el-input {
        width: 150px;
        float: none;

        .el-input__inner {
          height: 28px;
        }
      }

      .el-input--suffix {
        margin-right: 10px;
      }

      .selected {
        width: 450px;
        border: 1px solid #e2e2e2;
      }

      .box_button {
        display: flex;
        padding: 0;
        flex-direction: column;
        justify-content: center;

        .el-button {
          margin: 10px;
        }
      }
    }

    .el-dialog {
      border-radius: 25px;
    }

    .box-card {
      border-radius: 7px;
      height: 150px;
      width: 230px;
      margin: 30px 30px 0 30px;
    }



    .selectePages {
      height: 50px;
      width: 100%;
      text-align: right;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/auditNewRealTask/components/marketingProjectEditor.vue